import React, { ReactNode } from "react"
import { VerticallyCenteredBox } from "components/atoms"
import { Box, getIsAAACompliant, mq, Text, theme } from "@pallet-hq/hegel"
import styled from "@emotion/styled"
import { useTheme } from "@emotion/react"

type ContingencyTierOverviewSectionProps = {
    cta: ReactNode
}

const ContingencyTierOverviewSection = ({
    cta,
}: ContingencyTierOverviewSectionProps) => {
    // @ts-ignore
    const { colors } = useTheme()
    const isColorReadable = getIsAAACompliant(
        colors.primary,
        theme.colors.gray800
    )

    return (
        <DivWrapper>
            <MainWrapper>
                <VerticallyCenteredBox gap={theme.space.xsmall}>
                    <Text variant="headlineMedium" color="gray100">
                        Boutique
                    </Text>
                </VerticallyCenteredBox>
                <Description
                    variant="paragraphMedium"
                    mb="auto"
                    color="gray400"
                >
                    A full-service hiring solution, custom to your needs.
                </Description>
                <VerticallyCenteredBox mt="small" gap={theme.space.xsmall}>
                    <Text
                        variant="titleSmall"
                        color={isColorReadable ? colors.primary : "gold200"}
                    >
                        15%
                    </Text>
                    <Box display="flex" flexDirection="column">
                        <Text variant="uiSmall500" color="gray400">
                            of first-year salary
                        </Text>
                        <Text variant="uiTiny500" color="gray600">
                            (Paid upon hire)
                        </Text>
                    </Box>
                </VerticallyCenteredBox>
                {cta}
                <Box mt="xsmall" width="100%" height="16px"></Box>
            </MainWrapper>
        </DivWrapper>
    )
}

export default ContingencyTierOverviewSection

const DivWrapper = styled.div`
    display: flex;
    position: relative;
    box-sizing: border-box;
    ${mq({ gridRow: [undefined, 2] })}
`

const MainWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: ${theme.space.small} ${theme.space.medium} ${theme.space.medium};
    background: ${theme.colors.gray800};
    background: radial-gradient(
        ellipse at right top,
        rgba(70, 70, 70, 1) 0%,
        rgba(30, 30, 30, 1) 65%
    );
    border-radius: 8px 8px 0 0;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.12);
    border: 1px solid ${theme.colors.gray800};
    border-bottom: 0;
`

const Description = styled(Text)`
    flex-grow: 1;
`
